import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoCadastro } from '../models/projeto-cadastro.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjetoCadastroService extends BaseService<ProjetoCadastro> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getCronogramaSearch(id: number, obj: any = null): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/cronograma/' + id, obj, { headers: this.headers });
  }

  public getBloqueio(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/bloqueio/' + id, obj, { headers: this.headers });
  }

  public listSimplesProjeto(): Observable<ProjetoCadastro[]> {
    return this.http.get<ProjetoCadastro[]>(this.baseUrl + '/list-simples', { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/cadastro';
  }

  public getById(id: number, filterProds: any = null): Observable<ProjetoCadastro> {
    return this.http.get<ProjetoCadastro>(this.baseUrl + '/' + id + '?filterProds=' + filterProds, { headers: this.headers });
  }

}
